var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.75,
    stroke: "#71B3DE",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7564 21.3945C15.9702 21.1806 16.0904 20.8906 16.0904 20.5882C16.0904 20.2858 15.9702 19.9957 15.7564 19.7819C15.5426 19.568 15.2525 19.4479 14.9501 19.4479V13.7465C14.9501 13.1417 14.7098 12.5616 14.2822 12.134C13.8545 11.7063 13.2744 11.466 12.6696 11.466C12.3671 11.466 12.0771 11.5861 11.8633 11.8C11.6494 12.0138 11.5293 12.3039 11.5293 12.6063C11.5293 12.9087 11.6494 13.1987 11.8633 13.4126C12.0771 13.6264 12.3671 13.7465 12.6696 13.7465V19.4479C12.6696 20.0527 12.9098 20.6328 13.3375 21.0605C13.7652 21.4882 14.3453 21.7284 14.9501 21.7284C15.2525 21.7284 15.5426 21.6083 15.7564 21.3945Z",
    fill: "#71B3DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8176 6.5248C11.6296 6.80608 11.5293 7.13677 11.5293 7.47506C11.5293 7.92868 11.7095 8.36373 12.0303 8.6845C12.351 9.00526 12.7861 9.18546 13.2397 9.18546C13.578 9.18546 13.9087 9.08515 14.19 8.89721C14.4712 8.70927 14.6905 8.44214 14.8199 8.1296C14.9494 7.81706 14.9832 7.47316 14.9172 7.14137C14.8512 6.80958 14.6883 6.50482 14.4491 6.26562C14.2099 6.02641 13.9052 5.86351 13.5734 5.79751C13.2416 5.73152 12.8977 5.76539 12.5852 5.89485C12.2726 6.0243 12.0055 6.24353 11.8176 6.5248Z",
    fill: "#71B3DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.8c779a5d09b4464b169e3d7eec873408.svg";
export { ForwardRef as ReactComponent };